import { Edit } from "react-admin"

import { GuestTemplateForm } from "./GuestTemplateForm"

export const GuestTemplateEdit = () => (
  <Edit mutationMode="pessimistic">
    <GuestTemplateForm isExisting />
  </Edit>
)
